import { z } from 'zod';

export type DeleteSharedReportsQuery = z.infer<typeof deleteSharedReportsQuerySchema>;

export const deleteSharedReportsQuerySchema = z.object({
  ids: z.array(z.uuid()).or(z.uuid()),
});
